<template>
  <div class="c-number-input">
    <input :type="inputType" ref="input" :value="rValue" @input="updateValue($event.target.value)" :placeholder="placeholder"/>
    <span class="close" v-show="value.length > 0"
          @click="cleanInput"></span>
  </div>
</template>
<style lang="scss" scoped>
  @import "./index";
</style>
<script>
  export default{
    name: 'c-number-input',
    props: {
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      inputType: {
        type: String,
        default: 'text'
      },
      formater: {
        type: Function,
        default: null
      }
    },
    data () {
      return {
        nowInput: ''
      }
    },
    components: {},
    created () {},
    mounted () {
      // Android有格式化回调的时候光标位置异常
      this.$refs.input.addEventListener('keyup', function (event) {
        event.preventDefault()
        event.target.selectionStart = event.target.value.length
        event.target.selectionEnd = event.target.value.length
      })
    },
    beforeDestroy () {},
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      },
      cleanInput () {
        this.$emit('input', '')
      }
    },
    computed: {
      rValue () {
        if (this.formater) {
          return this.formater(this.value)
        }
        return this.value
      }
    },
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?516fc84e